"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyToggleButtonGroup = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const StyledToggleButton = (0, material_1.styled)(material_1.ToggleButton)({
  [`&.${material_1.toggleButtonClasses.root}`]: {
    fontWeight: 700
  }
});

const SskyToggleButtonGroup = props => {
  const renderToggleButtons = () => {
    return props.items.map((item, index) => {
      return react_1.default.createElement(StyledToggleButton, {
        key: index,
        value: item.value,
        disabled: item.disabled,
        "aria-label": item.ariaLabel,
        "data-testid": item.dataTestId || `testId-${item.value}`,
        "data-tracking-id": item.dataTrackingId || `tracking-id-${item.value}`
      }, item.content);
    });
  };

  const onChange = (event, value) => {
    const noValue = value === null || Array.isArray(value) && value.length === 0;

    if (props.enforceValue && noValue) {
      return;
    }

    props.onClick(value);
  };

  return react_1.default.createElement(material_1.ToggleButtonGroup, {
    id: props.id,
    className: props.className,
    value: props.value,
    exclusive: props.exclusive,
    onChange: onChange,
    size: props.size,
    "aria-label": props.ariaLabel,
    "data-testid": props.dataTestId || `testId-${props.id || props.ariaLabel}`
  }, renderToggleButtons());
};

exports.SskyToggleButtonGroup = SskyToggleButtonGroup;
exports.default = react_1.default.memo(SskyToggleButtonGroup);